import React from 'react';
import { formatDate } from '../../utils/dateUtils';
import {
    ProjectMeta,
    MetaItem,
    MetaIcon,
    LastUpdated
} from '../../styles/ProjectCard.styles';

const ProjectMetaInfo = ({ project, hasBackground, totalCards, totalTodos, completedTodos, textColor }) => (
    <ProjectMeta hasBackground={hasBackground} textColor={textColor}>
        <MetaItem hasBackground={hasBackground} title="Total cards" textColor={textColor}>
            <MetaIcon>📋</MetaIcon>
            {totalCards} {totalCards === 1 ? 'card' : 'cards'}
        </MetaItem>

        {totalTodos > 0 && (
            <MetaItem hasBackground={hasBackground} title="Completed todos" textColor={textColor}>
                <MetaIcon>✓</MetaIcon>
                {completedTodos}/{totalTodos}
            </MetaItem>
        )}

        <LastUpdated
            hasBackground={hasBackground}
            title={project.updatedAt ? new Date(project.updatedAt).toLocaleString() : 'Never updated'}
            textColor={textColor}
        >
            Updated {formatDate(project.updatedAt)}
        </LastUpdated>
    </ProjectMeta>
);

export default ProjectMetaInfo;